import { render, staticRenderFns } from "./PcMenu.vue?vue&type=template&id=a848d844&"
import script from "./PcMenu.vue?vue&type=script&lang=js&"
export * from "./PcMenu.vue?vue&type=script&lang=js&"
import style0 from "./PcMenu.vue?vue&type=style&index=0&id=a848d844&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports